module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"download":"Pobierz","noDataToExport":"Brak danych do exportu","noFieldsSubmittedForExport":"Nie przekazano żadnych pól do wyeksportowania."}}')
  delete Component.options._Ctor
}
